import { create } from 'zustand';

import { renamePresetDimensionMap } from '@src/common/constant/emp';
import { EDimensionType, ERenamePreset } from '@src/common/constant/enum';

import { ETableSize, IPresetInfo } from '../typed';

interface IDimensionPanelState {
  preset: IPresetInfo | undefined;
  size: ETableSize;
  curPresetName: string;
  lockedDimensionNames: string[];
  eventAttributeDimensionNames: string[];
  setPreset: (preset: IPresetInfo | undefined) => void;
  setSize: (size: ETableSize) => void;
  setCurPresetName: (curPresetName: string) => void;
  setLockedDimensionNames: (names: string[]) => void;
  setEventAttributeDimensionNames: (names: string[]) => void;
}

export const useDimensionPanelStore = create<IDimensionPanelState>((set, get) => ({
  preset: undefined,
  size: ETableSize.AUTO,
  curPresetName: 'Explore',
  lockedDimensionNames: [],
  eventAttributeDimensionNames: [],
  setPreset: (newPreset: IPresetInfo | undefined) =>
    set(() => {
      if (!newPreset) return { preset: undefined };
      const curPresetName = get().curPresetName;
      const dimensions = newPreset.dimensions ?? [];
      // Update the target dimension table position to last one or 4 when in rename panel.
      if (curPresetName === ERenamePreset.PAGE || curPresetName === ERenamePreset.SCREEN) {
        const fixedDimensionName = renamePresetDimensionMap[curPresetName];
        const currentIndex = dimensions.findIndex((dimension) => {
          return (
            dimension.dimensionType === EDimensionType.CUSTOM_DIMENSION &&
            dimension.dimensionName === fixedDimensionName
          );
        });
        // has the target dimension and not at the right place.
        if (currentIndex !== -1 || (dimensions.length < 5 && currentIndex === dimensions.length)) {
          const targetDimension = dimensions.splice(currentIndex, 1)[0];
          dimensions.splice(3, 0, targetDimension);
        }
      }
      newPreset.dimensions = [...dimensions];
      return { preset: { ...newPreset } };
    }),
  setSize: (size: ETableSize) => set(() => ({ size })),
  setCurPresetName: (curPresetName: string) => set(() => ({ curPresetName })),
  setLockedDimensionNames: (names: string[]) => set(() => ({ lockedDimensionNames: names })),
  setEventAttributeDimensionNames: (names: string[]) =>
    set(() => ({ eventAttributeDimensionNames: names })),
}));
